import { Modal } from "antd";
import { FC } from "react";

import { useLoc } from "@app/shared/lib/hooks";

import { StudentPasswordForm } from "./components/StudentPasswordForm/StudentPasswordForm";

export const StudentPasswordBlocker: FC = () => {
  const loc = useLoc();

  return (
    <Modal
      open
      closable={false}
      title={loc.word("Student.setNewPassword", {
        default: "Set new password",
      })}
      footer={null}
      width={600}
      destroyOnHidden
    >
      <StudentPasswordForm />
    </Modal>
  );
};
